export default __webpack_public_path__ + "a68e690bfae3aa200de1fdc188c93868.jpg";